import { render, staticRenderFns } from "./ChromatographyTab.vue?vue&type=template&id=111baf22&scoped=true&"
import script from "./ChromatographyTab.vue?vue&type=script&lang=js&"
export * from "./ChromatographyTab.vue?vue&type=script&lang=js&"
import style0 from "./ChromatographyTab.vue?vue&type=style&index=0&id=111baf22&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111baf22",
  null
  
)

export default component.exports